import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class SnackbarMessageService {

  constructor(private snackBar: MatSnackBar) { }

  openSaveSuccessSnackBar(message?: string, action?: string) {
    this.snackBar.open(message || 'Salvo com sucesso', action || 'Fechar', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 2500,
      panelClass: ['message-success']
    });
  }

}
